module.exports = "<div ng-class=\"$ctrl.cardData.name\" class=\"card\">\n\n  <div class=\"card-description\">\n    <p class=\"textOne\">{{$ctrl.cardData.textLineOne | translate}}</p>\n    <p class=\"textTwo\">{{$ctrl.cardData.textLineTwo | translate}}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryCard/whatIsSolidaryCard.html
// module id = 2260
// module chunks = 0